import {observer} from "mobx-react";
import React from "react";
import {FormProps} from "../../core/form/formUtils";
import ProjectVersionLop from "../domain/project/projectVersionLopDomain";
import {DefinitionType} from "../../core/form/form";
import { MdTextField} from "../../core/components/fields/fields";
import {Validate} from "../../core/form/validate";
import {createForm} from "../../core/form/createForm";
import {ProjectVersionLifespan} from "../domain/project/projectVersionLifespanDomain";

@observer
class ProjectVersionLifespanForm extends React.Component<FormProps<ProjectVersionLifespan, ProjectVersionLifespan>, any> {

  render(): JSX.Element | false | null {
    let {dataObject} = this.props;
    let fields = dataObject.getFormFields(ProjectVersionLifespanFormDefinition.formName);
    let {
      groupName, subgroupName, elementName,minimalLifespan,maximalLifespan,averageLifespan
    } = fields;

    return (
      <div>
        <div className='row'>
          <div className='fx col-xs-6 col-sm-6'>
            <MdTextField {...groupName.props}/>
            <Validate field={groupName} value={groupName.props.value} />
          </div>
          <div className='fx col-xs-6 col-sm-6'>
            <MdTextField {...subgroupName.props}/>
            <Validate field={subgroupName} value={subgroupName.props.value} />
          </div>
        </div>
      </div>
    );
  }
}


export const ProjectVersionLifespanFormDefinition: DefinitionType = {
  formName: 'ProjectVersionLifespanForm',
  fields: [
    {name : 'groupName'},
    {name : 'subgroupName'},
    {name : 'elementName'},
    {name : 'minimalLifespan'},
    {name : 'maximalLifespan'},
    {name : 'averageLifespan'},
  ]
};

export default createForm(ProjectVersionLifespanFormDefinition, null)(ProjectVersionLifespanForm);



// WEBPACK FOOTER //
// ./src/sbtool/component/projectVersionLifespanForm.tsx